import React from 'react';
import { challengeCardBtn } from './ChallengeCard';

export default function ChallengeResolveActions({
	challenge,
	onComplete,
	onFail,
	disabled = false,
	completeButtonClassName = challengeCardBtn.success,
	failButtonClassName = challengeCardBtn.secondary
}) {
	if (!challenge?.can_fail) return null;

	const completeEnabled = Boolean(challenge.can_complete);
	const blockedMessage = challenge.day_tracking?.blocked_message;

	return (
		<>
			<button
				type="button"
				disabled={disabled || !completeEnabled}
				title={!completeEnabled ? blockedMessage || undefined : undefined}
				aria-disabled={disabled || !completeEnabled}
				onClick={() => {
					if (!completeEnabled || disabled) return;
					onComplete();
				}}
				className={`${completeButtonClassName}${completeEnabled ? '' : ' cursor-not-allowed opacity-50'}`}
			>
				Did it
			</button>
			<button
				type="button"
				disabled={disabled}
				onClick={onFail}
				className={failButtonClassName}
			>
				Didn't do it
			</button>
		</>
	);
}
